const {API_SERVER_URL} = process.env;

export default {
  ApiServerUrl: API_SERVER_URL,
};
